const MENU_BUTTON_NAME_MAX_LENGTH = 10

export { MENU_BUTTON_NAME_MAX_LENGTH }
